import URLSearchParams from 'url-search-params';
import { parentWindow } from './constants';

export default function postMessage(type) {
  const parentDomain = parentWindow.domain;
  if (parentDomain) {
    const content = document.getElementById('app');
    window.parent.postMessage(
      { type: type || 'RESIZE', value: content.offsetHeight },
      parentDomain
    );
  }
}

export function updateParentDomain() {
  const query = new URLSearchParams(location.search);
  const parentDomain = query.get('parentDomain');
  parentWindow.domain = parentDomain;
}



// WEBPACK FOOTER //
// ./app/utils/postMessage.js